export default "__VITE_ASSET__ef55b77d__"